import { Building, ContactRound, Flag, Globe } from "lucide-react";
import { DEFAULT_COUNTRY } from "../constants/generalConstants";
import { formatNumberToShortForm, getCurrentCustomerCount } from "./numberFormatHelper";

const countryMap: Record<string, string> = {
  af: "Afghanistan",
  al: "Albania",
  aq: "Antarctica",
  dz: "Algeria",
  ad: "Andorra",
  ao: "Angola",
  ar: "Argentina",
  am: "Armenia",
  au: "Australia",
  at: "Austria",
  az: "Azerbaijan",
  bb: "Barbados",
  bh: "Bahrain",
  bd: "Bangladesh",
  by: "Belarus",
  be: "Belgium",
  bz: "Belize",
  bj: "Benin",
  bt: "Bhutan",
  bo: "Bolivia",
  ba: "Bosnia and Herzegovina",
  bw: "Botswana",
  br: "Brazil",
  bn: "Brunei",
  bg: "Bulgaria",
  bf: "Burkina Faso",
  bi: "Burundi",
  kh: "Cambodia",
  cm: "Cameroon",
  ca: "Canada",
  cv: "Cape Verde",
  cf: "Central African Republic",
  td: "Chad",
  cl: "Chile",
  cn: "China",
  co: "Colombia",
  km: "Comoros",
  cg: "Congo",
  cd: "Congo (Democratic Republic)",
  ci: "Ivory Coast",
  cr: "Costa Rica",
  hr: "Croatia",
  cu: "Cuba",
  cy: "Cyprus",
  cz: "Czechia",
  dk: "Denmark",
  dj: "Djibouti",
  dm: "Dominica",
  do: "Dominican Republic",
  ec: "Ecuador",
  eg: "Egypt",
  sv: "El Salvador",
  gq: "Equatorial Guinea",
  er: "Eritrea",
  ee: "Estonia",
  et: "Ethiopia",
  fi: "Finland",
  fr: "France",
  ga: "Gabon",
  gm: "Gambia",
  ge: "Georgia",
  de: "Germany",
  gh: "Ghana",
  gr: "Greece",
  gt: "Guatemala",
  gn: "Guinea",
  gy: "Guyana",
  ht: "Haiti",
  hk: "Hong Kong",
  hn: "Honduras",
  hu: "Hungary",
  is: "Iceland",
  in: "India",
  id: "Indonesia",
  ir: "Iran",
  iq: "Iraq",
  ie: "Ireland",
  il: "Israel",
  it: "Italy",
  im: "Isle of Man",
  jm: "Jamaica",
  jp: "Japan",
  jo: "Jordan",
  kz: "Kazakhstan",
  ke: "Kenya",
  kr: "South Korea",
  kw: "Kuwait",
  kg: "Kyrgyzstan",
  la: "Laos",
  lv: "Latvia",
  lb: "Lebanon",
  ls: "Lesotho",
  lr: "Liberia",
  ly: "Libya",
  li: "Liechtenstein",
  lt: "Lithuania",
  lu: "Luxembourg",
  mg: "Madagascar",
  mw: "Malawi",
  my: "Malaysia",
  mv: "Maldives",
  ml: "Mali",
  mt: "Malta",
  mr: "Mauritania",
  mo: "Macau",
  me: "Montenegro",
  mu: "Mauritius",
  mx: "Mexico",
  md: "Moldova",
  mc: "Monaco",
  mn: "Mongolia",
  ma: "Morocco",
  mz: "Mozambique",
  mm: "Myanmar",
  mk: "North Macedonia",
  na: "Namibia",
  np: "Nepal",
  nl: "Netherlands",
  nz: "New Zealand",
  ni: "Nicaragua",
  ne: "Niger",
  ng: "Nigeria",
  no: "Norway",
  om: "Oman",
  pk: "Pakistan",
  ps: "Palestine",
  pa: "Panama",
  pg: "Papua New Guinea",
  py: "Paraguay",
  pe: "Peru",
  ph: "Philippines",
  pl: "Poland",
  pt: "Portugal",
  qa: "Qatar",
  ro: "Romania",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sn: "Senegal",
  rs: "Serbia",
  sg: "Singapore",
  sk: "Slovakia",
  si: "Slovenia",
  so: "Somalia",
  za: "South Africa",
  es: "Spain",
  lk: "Sri Lanka",
  sd: "Sudan",
  se: "Sweden",
  ch: "Switzerland",
  sy: "Syria",
  tw: "Taiwan",
  tj: "Tajikistan",
  tz: "Tanzania",
  th: "Thailand",
  tl: "Timor-Leste",
  tt: "Trinidad and Tobago",
  tg: "Togo",
  tn: "Tunisia",
  tr: "Turkey",
  tm: "Turkmenistan",
  ug: "Uganda",
  ua: "Ukraine",
  ae: "United Arab Emirates",
  uk: "United Kingdom",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  ve: "Venezuela",
  vn: "Vietnam",
  ye: "Yemen",
  zm: "Zambia",
  zw: "Zimbabwe",
  ag: "Antigua and Barbuda",
  ai: "Anguilla",
  as: "American Samoa",
  aw: "Aruba",
  ax: "Åland Islands",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bq: "Bonaire, Sint Eustatius and Saba",
  bs: "Bahamas",
  bv: "Bouvet Island",
  cc: "Cocos (Keeling) Islands",
  ck: "Cook Islands",
  cw: "Curaçao",
  cx: "Christmas Island",
  eh: "Western Sahara",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  gb: "United Kingdom",
  gd: "Grenada",
  gf: "French Guiana",
  gg: "Guernsey",
  gi: "Gibraltar",
  gl: "Greenland",
  gp: "Guadeloupe",
  gs: "South Georgia and the South Sandwich Islands",
  gu: "Guam",
  gw: "Guinea-Bissau",
  hm: "Heard Island and McDonald Islands",
  io: "British Indian Ocean Territory",
  je: "Jersey",
  ki: "Kiribati",
  kn: "Saint Kitts and Nevis",
  kp: "Korea (North)",
  ky: "Cayman Islands",
  lc: "Saint Lucia",
  mf: "Saint Martin",
  mh: "Marshall Islands",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  ms: "Montserrat",
  nc: "New Caledonia",
  nf: "Norfolk Island",
  nr: "Nauru",
  nu: "Niue",
  pf: "French Polynesia",
  pm: "Saint Pierre and Miquelon",
  pn: "Pitcairn",
  pr: "Puerto Rico",
  pw: "Palau",
  re: "Réunion",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sh: "Saint Helena",
  sj: "Svalbard and Jan Mayen",
  sl: "Sierra Leone",
  sm: "San Marino",
  sr: "Suriname",
  ss: "South Sudan",
  st: "Sao Tome and Principe",
  sx: "Sint Maarten",
  sz: "Eswatini",
  tc: "Turks and Caicos Islands",
  tf: "French Southern Territories",
  tk: "Tokelau",
  to: "Tonga",
  tv: "Tuvalu",
  um: "United States Minor Outlying Islands",
  va: "Vatican City",
  vc: "Saint Vincent and the Grenadines",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vu: "Vanuatu",
  wf: "Wallis and Futuna",
  ws: "Samoa",
  xk: "Kosovo",
  yt: "Mayotte",
};
export const getCountryName = (code: string): string => countryMap[code?.toLowerCase()] || DEFAULT_COUNTRY;
export const isKnownCountryCode = (code?: string | null): boolean => {
  if (!code) return false;
  return Object.prototype.hasOwnProperty.call(countryMap, code.toLowerCase());
};
export function getCountryCode(countryName?: string | null): string | undefined {
  if (!countryName || typeof countryName !== "string") return undefined;

  const entry = Object.entries(countryMap).find(
    ([, name]) => name.toLowerCase() === countryName.toLowerCase()
  );
  return entry ? entry[0] : undefined;
}

// Get assets images URL - Vite will replace process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES at build time via define config
// This works on both server (where process exists) and client (where Vite replaces it)
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const ASSETS_IMAGES_BASE = process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES || '';

export const teamAwards = [
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/2016-AREA-awards-finalist.avif`, alt: "AREA 2016 Award" },
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/2017-AREA-awards-finalist.avif`, alt: "AREA 2017 Finalist" },
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/2018-AREA-awards-finalist.avif`, alt: "AREA 2018 Finalist" },
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/2019-Telstra-business-awards-finalist.avif`, alt: "Telstra Business Awards 2019 Finalist" },
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/2019-Telstra-awards-finalist.avif`, alt: "Telstra Awards 2019 Finalist" },
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/2018-Finder-awards-finalist.avif`, alt: "Finder Award" },
  { src: `${ASSETS_IMAGES_BASE}/assets/meet-the-team/REA-annual-excellence-awards 1.avif`, alt: "REA Logo" },
];
let number = getCurrentCustomerCount({ isFormatted: false });
number = formatNumberToShortForm(number);
export const stats = [
  { icon: Globe, value: '110+', label: "Countries" },
  { icon: Flag, value: '2,500+', label: "Cities" },
  { icon: Building, value: '349K', label: "Office Listings" },
  { icon: ContactRound, value: `${number}`, label: "Customer" },
];

export const GRADE_OPTIONS = [
  { option: "Premium", value: "premium" },
  { option: "Superior", value: "superior" },
  { option: "Economical", value: "economical" },
];

export const SPACETYPE_OPTIONS = [
  {
    option: "Entire Office",
    value: "area-entire",
    description: "Not shared",
    icon: "/assets/icons/entire-office.svg"
  },
  {
    option: "Private Office",
    value: "area-shared",
    description: "Shared facilities",
    icon: "/assets/icons/private-office.svg"
  },
  {
    option: "Coworking Space",
    value: "desks",
    description: "Open Plan • Shared facilities",
    icon: "/assets/icons/coworking-space.svg"
  }
];
const regionCities: Record<string, string> = {
  au: "Sydney, Melbourne and Brisbane",
  uk: "London, Manchester and Birmingham",
  us: " New York, Los Angeles and Chicago",
  sg: "Raffles Place, Orchard and Marina Bay",
  in: "Mumbai, Delhi, Bangalore and Hyderabad",
  hk: "Central, Kowloon and Wan Chai",
  ca: "Toronto, Ottawa, Montreal, Vancouver and Calgary",
  ae: "Dubai, Abu Dhabi and Sharjah"
};
const regionProviders: Record<string, string> = {
  au: "Hub Australia, Regus, Servcorp, Spaces",
  uk: "The Office Group, Regus, Workspace Group, Huckletree, Spaces",
  us: "Industrious, Regus, Spaces, Convene, Knotel",
  sg: "JustCo, The Hive, Distrii, The Executive Centre, Spaces",
  in: "Awfis, Smartworks, Incuspaze, 91Springboard, IndiQube",
  hk: "The Hive, The Executive Centre, Compass Offices, Spaces, Garage Society",
  ca: "Breather, Regus, IQ Office Suites, Spaces, The Professional Centre",
  ae: "The Place Business Centres, Letswork, Servcorp, Regus, Astrolabs"
};
export const getFormattedCountryName = (
  region: string,
  useFullName: boolean = false
) => {
  const code = region?.toLowerCase();

  if (code === "us") {
    return useFullName ? "the United States" : "the US";
  }

  if (code === "uk") {
    return useFullName ? "the United Kingdom" : "the UK";
  }

  return getCountryName(region);
};
export const getFormattedCityNames = (countryCode: string): string => {
  return regionCities[countryCode?.toLowerCase()] || "major cities";
};
export const getFormattedProvidersNames = (countryCode: string): string => {
  return regionProviders[countryCode?.toLowerCase()] || "Regus, JustCo, Spaces, Servcorp and The Hives";
};
